import { tns } from 'tiny-slider/src/tiny-slider';
import whenDomReady from 'when-dom-ready';
function initialise() {
    const elements = Array.from(document.querySelectorAll('.js-awards-carousel'));
    if (!elements) {
        return;
    }
    elements.forEach(element => {
        const controls = element.querySelector('.js-awards-carousel-controls');
        const track = element.querySelector('.js-awards-carousel-track');
        const progress = element.querySelector('.js-progress-bar');
        const items = element.querySelectorAll('.js-award-item');
        const slider = tns({
            autoplay: false,
            autoplayButtonOutput: false,
            autoplayHoverPause: true,
            center: false,
            container: track,
            controlsContainer: controls,
            edgePadding: 15,
            gutter: 30,
            items: 1,
            loop: false,
            nav: false,
            slideBy: 1,
            speed: 1500,
            touch: true,
            responsive: {
                768: {
                    items: 2,
                    slideBy: 2,
                },
                1024: {
                    items: 3,
                    slideBy: 3,
                },
            },
        });
        const sliderInfo = slider.getInfo();
        let progressWidth = (sliderInfo.slideBy / items.length) * 100;
        progress?.setAttribute('style', `--progress-width: ${progressWidth}%`);
        slider.events.on('indexChanged', event => {
            progressWidth = ((event.index + sliderInfo.slideBy) / event.slideCount) * 100;
            progress?.setAttribute('style', `--progress-width: ${progressWidth}%`);
        });
    });
}
whenDomReady().then(initialise);
